import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DayScale from './DayScale/DayScale';
import { PlannerEmployee } from '../interfaces';
import StyledWrapper from './Wrapper.styled';

interface RangeScaleDaysProps {
  rangeDays: Date[];
  employees: PlannerEmployee[];
}

export default function RangeScaleDays({
  rangeDays,
  employees,
}: RangeScaleDaysProps) {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      width="100%"
      borderTop="0.1rem solid"
      position="sticky"
      top="16.8rem"
      bgcolor="background.list"
      borderBottom="0.1rem solid"
      borderColor="border.main"
    >
      <StyledWrapper direction="row">
        <Typography variant="body2" fontWeight={700}>
          {t('employees.header_name')}
        </Typography>
        <Chip
          label={
            <Typography variant="chipLabel">{employees.length}</Typography>
          }
          size="small"
          variant="outlined"
        />
      </StyledWrapper>
      <Stack direction="row" width="100%">
        {rangeDays.map((day, index) => (
          <DayScale
            key={day.toISOString()}
            startDate={day}
            hideBorder={index === rangeDays.length - 1}
          />
        ))}
      </Stack>
    </Stack>
  );
}
